import type { ComponentProps, JSX } from "solid-js";

export type ButtonProps = ComponentProps<"button"> & {
  tone?: "primary" | "quiet";
  leadingIcon?: JSX.Element;
};

export function Button(props: ButtonProps) {
  const tone = () => props.tone ?? "primary";

  return (
    <button
      {...props}
      class={`sn-button sn-button--${tone()} ${props.class ?? ""}`.trim()}
    >
      {props.leadingIcon ? <span class="sn-button__icon">{props.leadingIcon}</span> : null}
      <span>{props.children}</span>
    </button>
  );
}
